import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/poller-one/400.css'
import '../styles/globals.css'

import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { setupChunkErrorRecovery } from '@/app/chunk-error-recovery'
import { AppErrorBoundary } from '@/app/error-boundary'
import { MaintenancePage } from '@/app/maintenance-page'

setupChunkErrorRecovery()

const AppRouter = lazy(() => import('@/app/app-router'))

function syncDocumentLanguage() {
  try {
    const match = document.cookie.match(/(?:^|; )lang=(en|zh)(?:;|$)/)
    const stored = localStorage.getItem('lang') || localStorage.getItem('user-locale')
    let lang = match?.[1] || stored
    if (lang !== 'en' && lang !== 'zh') {
      lang = navigator.language?.toLowerCase().startsWith('zh') ? 'zh' : 'en'
    }
    document.documentElement.lang = lang
  } catch {
    document.documentElement.lang = 'en'
  }
}

syncDocumentLanguage()

const DEPLOY_ACCESS_KEY = 'opencreator_deploy'
const DEPLOY_ACCESS_VALUE = 'deploy'

function canEnterApp() {
  try {
    return window.localStorage.getItem(DEPLOY_ACCESS_KEY) === DEPLOY_ACCESS_VALUE
  } catch {
    return false
  }
}

const root = document.getElementById('root')

if (!root) {
  throw new Error('Root element #root was not found')
}

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      {canEnterApp() ? (
        <Suspense fallback={null}>
          <AppRouter />
        </Suspense>
      ) : (
        <MaintenancePage />
      )}
    </AppErrorBoundary>
  </StrictMode>
)
